import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { integrationConnectionWithAccountsResponseSchema } from "@common/schemas/domains/integrationConnection/integration-connection-response.schema";

const c = initContract();

export const paypalContract = c.router(
    {
        createConnection: {
            method: "POST",
            path: "/",
            body: z.object({
                /**
                 * Omitted when an accounting firm connects from the
                 * organization view: the connection is created without a
                 * client and its accounts are assigned afterwards.
                 */
                workspaceId: z.string().uuid().optional(),
                sharedId: z.string(),
                authCode: z.string(),
                defaultEntityId: z.number().optional(),
            }),
            responses: {
                201: integrationConnectionWithAccountsResponseSchema,
            },
        },
        migrateFromPlaid: {
            method: "POST",
            path: "/migrate-from-plaid",
            body: z.object({
                plaidConnectionId: z.number(),
                sharedId: z.string(),
                authCode: z.string(),
            }),
            responses: {
                201: integrationConnectionWithAccountsResponseSchema,
            },
        },
    },
    {
        pathPrefix: "/paypal",
    },
);
